import { createHash } from "node:crypto";
import sodium from "libsodium-wrappers-sumo";

/**
 * A time-/memory-hard hashing function that is suitable for passwords.
 */
export function slow_hash(
  input: string | Uint8Array,
  salt: string | Uint8Array,
  length: number,
): Uint8Array {
  const saltHash = quick_hash(salt, sodium.crypto_pwhash_SALTBYTES);

  return sodium.crypto_pwhash(
    length,
    input,
    saltHash,
    sodium.crypto_pwhash_OPSLIMIT_MODERATE,
    sodium.crypto_pwhash_MEMLIMIT_MODERATE,
    sodium.crypto_pwhash_ALG_ARGON2ID13,
  );
}

/**
 * A simple hashing function that is not suitable for passwords or other sensitive material.
 */
export function quick_hash(
  input: string | Uint8Array,
  length: number,
): Uint8Array {
  return sodium.crypto_generichash(length, input);
}

/**
 * This is preserved for legacy usage in some endpoints and should not be used in new code.
 */
export function sha1_LEGACY_DO_NOT_USE(input: string): string {
  const h = createHash("sha1");
  h.update(input);
  return h.digest("hex");
}
